import { useState } from "react";
import { Button } from "@mui/material";
import useReportStore from "../../../store/reports";
import axios from "../../../axios";


const downloadFile = async ({url, method="GET", contentType = "text/csv; charset=utf-8"}) => {

  const data = await axios({
    method: method,
    url: url,
    responseType: 'blob',
    timeout: 60000,
    headers: {
      "Content-Type": contentType,
      "Content-disposition": "attachment;"
    }
  })
  console.log(data, "heeeeyy");

  let filename = data.headers["content-disposition"].split("filename=")[1]

  const elem = window.document.createElement('a');
  elem.href = window.URL.createObjectURL(data.data);
  elem.download = filename;        
  document.body.appendChild(elem);
  elem.click();        
  document.body.removeChild(elem);
}



const ExportCsv = () => {
  const reportType = useReportStore(state => state.reportType);
  const filterString = useReportStore(state => state.filterString[reportType]);
  const staticFilterString = useReportStore(state => state.staticFilterString[reportType]);
  const reportResults = useReportStore(state => state.reportResults);

  const [loading, setLoading] = useState(false);

  let finalString = filterString;

  // const { data: list, pagination, setPagination, isLoading } = useSimpleTable({url: `/reports/${reportType}/detailed`, filterString: finalString, enabled: !isEmpty(totals)});

  const downloadCSV = async () => {
    let url = `/reports/${reportType}/detailed?${finalString}&[ignore][download]=csv`
    if (staticFilterString) url += `&${staticFilterString}`
    try {
      setLoading(true)
      await downloadFile({url});
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button variant="outlined" onClick={downloadCSV} loading={loading} type="button">Export CSV</Button>
  )
};

export default ExportCsv;